import schemaTableDataActionTypes from "./schema-tabledata.types";

const INITIAL_STATE = {
  customerData: {},
  loginAudit: {},
  viewAnnouncements: {},
  viewUsers: {},
  alarms:{}
};

const schemaTableDataReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case schemaTableDataActionTypes.SIGNOUT_SUCCESS:
      // let values = {};
      // Object.entries(state).forEach(([key, value]) => {
      //   values = { ...values, [key]: {} }
      // })
      return {
        customerData: {},
        loginAudit: {},
        viewAnnouncements: {},
        viewUsers: {},
        alarms:{}
      }
    case schemaTableDataActionTypes.REMOVE_SCHEMA_TABLE_DATA:
      return {
        ...state,
        [action.payloadKey]: {
          schema: null,
          tableData: null,
          pagination_meta_data: null,
        }
      };
    case schemaTableDataActionTypes.SET_SCHEMA_TABLE_DATA:
      return {
        ...state,
        [action.payloadKey]: {
          schema: action.payload.schema,
          tableData: action.payload.tableData,
          pagination_meta_data: action.payload.pagination_meta_data,
        },
      };
    default:
      return state;
  }
};

export default schemaTableDataReducer;
